import { CreditServiceType, CreditTransactionStatus } from 'api/Credit/types';
import { SelectOption } from 'app/types/Forms';

export const getStatusColor = (status: CreditTransactionStatus) => {
  switch (status) {
    case 'COMPLETED':
      return 'purple';
    case 'RESERVED':
      return 'default';
    default:
      return 'red';
  }
};

export const serviceTypeOptions: SelectOption<CreditServiceType>[] = [
  { label: 'Execute GNT', value: 'EXECUTE_MODEL_GNT' },
  { label: 'Execute WGS', value: 'EXECUTE_MODEL_WGS' },
  { label: 'Ancestry PDF report generation', value: 'GENERATE_PDF_REPORT_ANCESTRY' },
  { label: 'PRS RUO Cardio PDF report generation', value: 'GENERATE_PDF_REPORT_PRS_RUO_CARDIO' },
  { label: 'PRS RUO Cancer PDF report generation', value: 'GENERATE_PDF_REPORT_PRS_RUO_CANCER' },
  { label: 'PRS Clinical Cardio PDF report generation', value: 'GENERATE_PDF_REPORT_PRS_CLINICAL_CARDIO' },
  { label: 'PRS Clinical Cancer PDF report generation', value: 'GENERATE_PDF_REPORT_PRS_CLINICAL_CANCER' },
  { label: 'Replenishment / Write off', value: 'REPLENISHMENT' },
];
